"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const CaseStatus = (props) => {
    const { caseStatus, caseData } = props;
    return (react_1.default.createElement("div", { className: `case-status-container ${caseStatus.className}-background` },
        react_1.default.createElement("div", { className: "titles" },
            (caseData.date || caseData.deadline) &&
                react_1.default.createElement("p", { className: "item" }, caseData.deadline ? 'Deadline:' : 'Date:'),
            react_1.default.createElement("p", { className: "item" }, "Status:")),
        react_1.default.createElement("div", { className: "texts" },
            caseData.deadline &&
                react_1.default.createElement("p", { className: "item" }, moment_1.default(caseData.deadline).utc().format('MMM D, h:mm a').toUpperCase()),
            caseData.date &&
                react_1.default.createElement("p", { className: "item" }, moment_1.default(caseData.date).utc().format('MMM D, h:mm a').toUpperCase()),
            react_1.default.createElement("p", { className: "item" }, caseStatus.name))));
};
exports.default = CaseStatus;
